"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitIndustryPassAttestationBodyToJSON = exports.SubmitIndustryPassAttestationBodyFromJSONTyped = exports.SubmitIndustryPassAttestationBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
function SubmitIndustryPassAttestationBodyFromJSON(json) {
    return SubmitIndustryPassAttestationBodyFromJSONTyped(json, false);
}
exports.SubmitIndustryPassAttestationBodyFromJSON = SubmitIndustryPassAttestationBodyFromJSON;
function SubmitIndustryPassAttestationBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'passAmount': json['passAmount'],
        'notes': !(0, runtime_1.exists)(json, 'notes') ? undefined : json['notes'],
    };
}
exports.SubmitIndustryPassAttestationBodyFromJSONTyped = SubmitIndustryPassAttestationBodyFromJSONTyped;
function SubmitIndustryPassAttestationBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'passAmount': value.passAmount,
        'notes': value.notes,
    };
}
exports.SubmitIndustryPassAttestationBodyToJSON = SubmitIndustryPassAttestationBodyToJSON;
